import React, { useState } from 'react';
import GameHeader from './game-header';
import { Button, Space } from 'antd';

const DanceMat = () => {

  document.title = "CS Lab | Dance Mat Typing";

  const [currentLevel, setCurrentLevel] = useState(1);

  const handleLevelChange = (level) => {
    setCurrentLevel(level);
  };

  return (
    <div className="container-fluid p-0">
      <div className="row mt-1">
        <div className="col">
          <GameHeader headerName="Dance Mat Typing" />
          <div style={{ marginTop: '16px' }}>
            <Space wrap>

              <Button
                type={currentLevel === 1 ? "primary" : "default"}
                style={{ marginRight: "8px" }}
                onClick={() => handleLevelChange(1)}
              >
                Level 1
              </Button>
              <Button
                type={currentLevel === 2 ? "primary" : "default"}
                style={{ marginRight: "8px" }}
                onClick={() => handleLevelChange(2)}
              >
                Level 2
              </Button>
              <Button
                type={currentLevel === 3 ? "primary" : "default"}
                style={{ marginRight: "8px" }}
                onClick={() => handleLevelChange(3)}
              >
                Level 3
              </Button>
              <Button
                type={currentLevel === 4 ? "primary" : "default"}
                style={{ marginRight: "8px" }}
                onClick={() => handleLevelChange(4)}
              >
                Level 4
              </Button>

            </Space>
          </div>
          <div style={{ marginTop: '16px' }}>
            <iframe
              id="danceMatIframe"
              src={getIframeURL(currentLevel)}
              title="Dance Mat Typing"
              style={{
                width: '100%',
                height: '100vh',
                border: 'none',
              }}
            ></iframe>
          </div>

        </div>
      </div>
    </div>
  );
};

const getIframeURL = (level) => {
  switch (level) {
    case 1:
      return 'https://www.bbc.co.uk/games/interactive/activity-dance-mat-typing?exitGameUrl=http%3A%2F%2Fwww.bbc.co.uk%2Fguides%2Fz3c6tfr';
    case 2:
      return 'https://www.bbc.co.uk/games/interactive/activity-dance-mat-typing-level2?exitGameUrl=http%3A%2F%2Fwww.bbc.co.uk%2Fguides%2Fz3c6tfr';
    case 3:
      return 'https://www.bbc.co.uk/games/interactive/activity-dance-mat-typing-level3?exitGameUrl=http%3A%2F%2Fwww.bbc.co.uk%2Fguides%2Fz3c6tfr';
    case 4:
      return 'https://www.bbc.co.uk/games/interactive/activity-dance-mat-typing-level4?exitGameUrl=http%3A%2F%2Fwww.bbc.co.uk%2Fguides%2Fz3c6tfr';
    default:
      return 'https://www.bbc.co.uk/games/interactive/activity-dance-mat-typing?exitGameUrl=http%3A%2F%2Fwww.bbc.co.uk%2Fguides%2Fz3c6tfr';
  }
};

export default DanceMat;
